import { ERROR, REJECT_REASON } from '../../constants'

export const notificationConfig = {
  [REJECT_REASON.phx_error]: {
    text: ERROR.serverIssues,
    type: 'warning',
  },
} as const

export const notificationToastOptions = {
  position: 'top-right',
} as const
